import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { chartLinks } from 'constants';
import { lowerCase } from 'lodash';

import { iaRa } from 'lib/helpers/utility';

import Popover from 'components/shared/Popovers/Popover/Popover';

const ChartLinks = () => {
  const { id } = useParams();
  const { pathname } = useLocation();

  const options = iaRa(chartLinks).map((item) => {
    const isActive = pathname?.includes(item?.path) && item.path !== '';

    return {
      icon: item.icon,
      label: item.label,
      onClick: () => {
        window.open(
          item.path ? `/portal/charts/${id}/${item.path}` : `/portal/charts/${id}/`,
          '_blank'
        );
      },
      'data-qa': item?.path || lowerCase(item.label),
      className: `group hover:bg-primary-50 ${isActive ? '!bg-primary-25' : ''}`
    };
  });

  return (
    <Popover
      isFixed
      isDropdown
      text="Clinical Notes"
      position="right"
      iconRightColor="white"
      options={options}
      optionActiveIcon={false}
      icon={null}
      iconRight="chevron-down-linear"
      buttonClassName="flex h-[32px] text-[14px] w-[142px] text-white border-none cursor-pointer items-center justify-center rounded-md  bg-primary-800 hover:bg-primary-700 p-0"
      panelClassName="mt-[6px]"
      data-qa="chart-links-menu"
    />
  );
};

export default ChartLinks;
